import { history } from "../../src/index";

import * as types from '../constants/assigneedetails';
import * as toasterTypes from '../constants/ActionTypes';
import * as assigneedetailsApi from '../api/assigneedetails';

export function resetAssignee() {
    // console.log("resetCustomer action call");
    return dispatch => {
        dispatch({ type: types.FETCH_ASSIGNEE_RESET });
    }
}

export function setAssigneeDetails(data) {
    // console.log("getAssigneeDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_ASSIGNEE_REQUEST_COMPLETED, data: data });
    }
}

export function getAssigneeDetails(id) {
    // console.log("getAssigneeDetails action call");
    return dispatch => {
        dispatch({ type: types.FETCH_ASSIGNEE_REQUEST });
        assigneedetailsApi.getAssignee(id)
            .then(function (response) {
                // console.log("getAssigneeDetails", response)
                dispatch({ type: types.FETCH_ASSIGNEE_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getAssigneeDetails Error", err)
                dispatch({ type: types.FETCH_ASSIGNEE_REQUEST_ERROR });
            });
    }
}

export function getAssigneeDetailsList(committee_id) {
    // console.log("getAssigneeDetailsList action call");
    return dispatch => {
        dispatch({ type: types.FETCH_ASSIGNEE_LIST_REQUEST });
        assigneedetailsApi.getAssigneeList(committee_id)
            .then(function (response) {
                // console.log("getAssigneeDetailsList", response)
                dispatch({ type: types.FETCH_ASSIGNEE_LIST_REQUEST_COMPLETED, data: response.data });
            })
            .catch(function (err) {
                // console.log("getAssigneeDetailsList Error", err)
                dispatch({ type: types.FETCH_ASSIGNEE_LIST_REQUEST_ERROR });
            });
    }
}

export function addAssigneeDetails(objModel) {
    // console.log("addAssigneeDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_ASSIGNEE_REQUEST });
        assigneedetailsApi.addAssignee(objModel)
            .then(function (response) {
                // console.log("addAssigneeDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_ASSIGNEE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Saved Successfully" });
                    history.push('/assignee/assignee-list/'+objModel.under_committtee_val);
                }
                dispatch({ type: types.ADD_ASSIGNEE_RESET });
            })
            .catch(function (err) {
                // console.log("addAssigneeDetails action err", err)
                dispatch({ type: types.ADD_ASSIGNEE_REQUEST_ERROR });
            });
    }
}

export function updateAssigneeDetails(objModel) {
    // console.log("addAssigneeDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_ASSIGNEE_REQUEST });
        assigneedetailsApi.updateAssignee(objModel)
            .then(function (response) {
                // console.log("addAssigneeDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_ASSIGNEE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Updated Successfully" });
                    history.push('/assignee/assignee-list/'+objModel.under_committtee_val);
                }
                dispatch({ type: types.ADD_ASSIGNEE_RESET });
            })
            .catch(function (err) {
                // console.log("addAssigneeDetails action err", err)
                dispatch({ type: types.ADD_ASSIGNEE_REQUEST_ERROR });
            });
    }
}

export function deleteAssigneeDetails(id,committee_id) {
    // console.log("addAssigneeDetails action call",objModel);
    return dispatch => {
        dispatch({ type: types.ADD_ASSIGNEE_REQUEST });
        assigneedetailsApi.deleteAssignee(id)
            .then(function (response) {
                // console.log("addAssigneeDetails action succ", response)
                if (response.status == 200) {
                    dispatch({ type: types.ADD_ASSIGNEE_REQUEST_COMPLETED });
                    dispatch({ type: toasterTypes.DISPLAY_SUCCESS, message: "Deleted Successfully" });
                    history.push('/assignee/assignee-list/'+committee_id);
                }
                dispatch({ type: types.ADD_ASSIGNEE_RESET });
            })
            .catch(function (err) {
                // console.log("addAssigneeDetails action err", err)
                dispatch({ type: types.ADD_ASSIGNEE_REQUEST_ERROR });
            });
    }
}


// WEBPACK FOOTER //
// ./actions/assigneedetails.js